import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import T from 'i18n-react';
import FirstImage from '../../../images/signup/communication.png';
import SecondImage from '../../../images/signup/work.png';
import ThirdImage from '../../../images/signup/rest.png';
import AuthContent from '../components/AuthContent';
import AppAvatar from '../../core/Avatar/AppAvatar';

const styles = (theme) => ({
  container: {
    maxWidth: theme.breakpoints.values.lg,
    margin: theme.spacing(5, 'auto'),
    padding: theme.spacing(0),
    flexWrap: 'wrap',
    flexDirection: 'column-reverse',
    [theme.breakpoints.up('md')]: {
      flexWrap: 'nowrap',
      flexDirection: 'row',
      padding: theme.spacing(0, 5),
      margin: theme.spacing(10, 'auto'),
    },
  },
  messageItem: {
    border: `1px solid ${theme.props.border.secondary.main}`,
    backgroundColor: theme.props.backgroundColor.primary.main,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    margin: theme.spacing(3, 'auto', 0),
    maxWidth: theme.breakpoints.values.sm,
    width: `calc(100% - ${theme.spacing(2) * 2}px)`,
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(0, 1.5, 0, 0),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4),
    },
  },
  loginItem: {
    padding: theme.spacing(0),
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing(0, 2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4),
      margin: theme.spacing(0, 0, 0, 1.5),
      border: `1px solid ${theme.props.border.primary.main}`,
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(18),
    marginBottom: theme.spacing(2.5),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(22),
    },
  },
  subheader: {
    display: 'flex',
    justifyContent: 'center',
    color: '#333333',
    marginBottom: theme.spacing(3.5),
    fontSize: theme.typography.pxToRem(14),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  image: {
    width: '100%',
    height: '100%',
  },
  skeleton: {
    position: 'relative',
    width: '100%',
    paddingTop: '72%',
    borderRadius: 80,
  },
  message: {
    color: '#333333',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 'bold',
    textDecoration: 'underline',
    textDecorationColor: theme.palette.primary.main,
    textDecorationStyle: 'dotted',
    textUnderlineOffset: `${theme.spacing(0.5)}px`,
    textDecorationThickness: `${theme.spacing(0.25)}px`,
    lineHeight: 1.7,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(16),
      padding: `${theme.spacing(1.5, 0, 1.5, 1.5)}!important`,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(18),
    },
  },
});

class Signup extends React.Component {
  messageContainerRenderer(image, message) {
    const { classes } = this.props;

    return (
      <Grid container alignItems="center" spacing={3}>
        <Grid item xs={5}>
          <AppAvatar
            src={image}
            loaded
            variant="rounded"
            className={classes.image}
            SkeletonProps={{ className: classes.skeleton }}
          />
        </Grid>
        <Grid item xs={7} className={classes.message} component={Typography}>
          {message}
        </Grid>
      </Grid>
    );
  }

  render() {
    const { classes, universityInvitationCode } = this.props;

    const authParams = {
      ...(universityInvitationCode && { universityInvitationCode }),
    };

    return (
      <Grid container className={classes.container}>
        <Grid item sm={12} md={6} className={classes.messageItem}>
          <Typography className={classes.header}>
            {T.translate('logins.findPlace')}
          </Typography>
          <Typography className={classes.subheader}>
            {T.translate('logins.signupSubheader')}
          </Typography>
          {this.messageContainerRenderer(
            FirstImage,
            T.translate('logins.firstMessage'),
          )}
          {this.messageContainerRenderer(
            SecondImage,
            T.translate('logins.secondMessage'),
          )}
          {this.messageContainerRenderer(
            ThirdImage,
            T.translate('logins.thirdMessage'),
          )}
        </Grid>
        <Grid item sm={12} md={6} className={classes.loginItem}>
          <AuthContent signup authParams={authParams} />
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(Signup);
